"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTiles = void 0;
var classnames_1 = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var ActionTile_1 = require("./ActionTile");
var ActionTiles = function (props) {
    var columnCountToGridSystemClass = function (maxColumnCount) {
        switch (maxColumnCount) {
            case 2:
                return 'col-12 col-md-6';
            case 3:
                return 'col-12 col-md-6 col-lg-4';
            case 4:
                return 'col-12 col-md-6 col-lg-4 col-xl-3';
            default:
                return 'col-12 col-md-6 col-lg-4 col-xl-3';
        }
    };
    var listItemClassNames = (0, classnames_1.default)('action-tiles__list-item', columnCountToGridSystemClass(props.maxColumnCount));
    return (React.createElement("div", { className: (0, classnames_1.default)('action-tiles', props.className) },
        props.heading &&
            React.createElement("h2", null, props.heading),
        React.createElement("ul", { className: "action-tiles__list row" }, props.options.map(function (option) {
            var actiontile = {
                description: option.description,
                divider: option.divider,
                hyperLink: option.hyperLink,
                hyperLinkText: option.hyperLinkText,
                id: props.id + "-" + option.id,
                pictogram: option.pictogram,
                title: option.title,
            };
            return (React.createElement("li", { className: listItemClassNames, key: "action-tile-" + props.id + "-" + option.id },
                React.createElement(ActionTile_1.ActionTile, __assign({}, actiontile))));
        }))));
};
exports.ActionTiles = ActionTiles;
/* tslint:disable:no-string-literal */
exports.ActionTiles['propTypes'] = {
    className: PropTypes.string,
    heading: PropTypes.string,
    id: PropTypes.string.isRequired,
    maxColumnCount: PropTypes.number,
    options: PropTypes.array.isRequired,
};
/* tslint:enable:no-string-literal */
